import Dialog from './dialog.element.js';

export default Dialog;

Dialog.define('wje-dialog', Dialog);
